(function ($) {
    $(".js-navigate-select").each(function () {
        const $select = $(this);
        let committedValue = $select.val();

        $select.on("keyup", function (e) {
            if (e.key === "Enter") {
                navigate(e);
            } else if (e.key === "Escape") {
                $select.val(committedValue);
            }
        });

        $select.on("click", navigate);

        function navigate(e) {
            const url = $select.val();
            // Only navigate if the selected filter has changed
            if (url && url !== committedValue) {
                e?.preventDefault();
                committedValue = url;
                document.location.href = url;
            }
        }
    });
})(jQuery);
